(function () {
  const searchModal = () => {
    $(
      ".search-modal-trigger,.search-modal__overlay,.search__close,.header__modal-close-search-button"
    ).click(function (e) {
      e.preventDefault();
      searchToggle();
    });
  };
  $(document).on("keyup", function (e) {
    if ($(".search-modal").hasClass("active") && e.key == "Escape") {
      searchToggle();
    }
  });
  function searchToggle() {
    $("#search-modal").toggleClass("active");
    $(".header-overlay").toggleClass("color-background-1");
    if ($("#search-modal").hasClass("active")) {
      $("#search-modal").find(".search__input").focus();
      $(".header-overlay").addClass("color-background-1");
    } else {
      $(".search-modal-trigger").focus();
    }
    $("body").toggleClass("overflow-hidden");
    $(".header__modal-close-search-button").toggleClass("active");
  }
  document.addEventListener("shopify:section:load", searchModal);
  searchModal();
})();
